class AddToCartController {
  constructor() {
    this.state = {
      isDisabled: false,
    };

    this.subscribers = [];
  }

  subscribe(callback) {
    this.subscribers.push(callback);
  }

  notifySubscribers() {
    this.subscribers.forEach((callback) => callback(this.state));
  }

  setDisabled(isDisabled) {
    this.state.isDisabled = isDisabled;
    this.notifySubscribers();
  }
}

const addToCartController = new AddToCartController();
export default addToCartController;
